<template>
  <div>
    <RefurbishedPrice
      v-if="product.type !== 'Brand new'"
      :is-discount-reassurance-displayed="Boolean(selectedOffer.discount)"
      :price-when-new="product.priceWhenNew"
    />
    <div class="flex flex-wrap items-baseline gap-x-4">
      <span
        class="heading-2"
        data-qa="productpage-product-price"
        data-test="productpage-product-price"
      >
        {{ i18n.price(price) }}
      </span>
      <PriceLabel
        v-if="selectedOffer.price"
        :buyback-offer
        :price="selectedOffer.price"
        :price-due-today
      />
    </div>

    <div class="flex flex-wrap items-center gap-x-8">
      <OriginalPrice
        v-if="product.type !== 'Brand new'"
        :is-discount-reassurance-displayed="Boolean(selectedOffer.discount)"
        :price-when-new="product.priceWhenNew"
      />
    </div>

    <div class="flex flex-wrap items-center gap-x-8">
      <VatIncluded class="mt-4" />
    </div>

    <StockLabel :stock-label="selectedOffer.stockLabel" />
  </div>
</template>

<script lang="ts" setup>
// fixme: duplicated code due to Japan improved PP
import type { Price } from '@backmarket/http-api'
import type { MobilePlanOffer } from '@backmarket/http-api/src/api-specs-b2c-services/mobile-plan/types/mobile-plan-offers'
import type { GetPickersResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/pickers'
import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'
import { useBuybackOffer } from '@backmarket/nuxt-layer-buyback/composables/buybackOffer/useBuybackOffer'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import OriginalPrice from '~/scopes/product/components/Price/components/OriginalPrice/OriginalPrice.vue'
import PriceLabel from '~/scopes/product/components/Price/components/PriceLabel/PriceLabel.vue'
import RefurbishedPrice from '~/scopes/product/components/Price/components/RefurbishedPrice/RefurbishedPrice.vue'
import VatIncluded from '~/scopes/product/components/Price/components/VatIncluded/VatIncluded.vue'

import StockLabel from '../StockLabel/StockLabel.vue'

withDefaults(
  defineProps<{
    selectedOffer: NonNullable<GetPickersResponse['selectedOffer']>
    price: Price
    priceDueToday?: Price | null
    product: GetProductResponse
    mobilePlan?: MobilePlanOffer
    flashSalesDiscount?: Price
  }>(),
  {
    mobilePlan: undefined,
    priceDueToday: undefined,
    flashSalesDiscount: undefined,
  },
)

const i18n = useI18n()
const { buybackOffer } = useBuybackOffer()
</script>
